(function () {
    if (!window.bootstrap) {
        const dropdowns = document.querySelectorAll('.dropdown-toggle');
        if (dropdowns) {
            dropdowns.forEach((element) => {
                const dropdown = element.closest('.dropdown');
                element.onclick = function (e) {
                    e.preventDefault();

                    // undo expanded state for all other dropdowns
                    const allDropdowns = document.querySelectorAll('.dropdown');
                    allDropdowns.forEach((dd) => {
                        if (dd !== dropdown) {
                            const toggle = dd.querySelector('.dropdown-toggle');
                            const menu = dd.querySelector('.dropdown-menu');
                            if (toggle) {
                                toggle.setAttribute("aria-expanded", "false");
                                toggle.classList.remove("show");
                            }
                            if (menu) {
                                menu.classList.remove("show");
                            }
                        }
                    });

                    const expanded = element.getAttribute("aria-expanded") == "true";
                    if (expanded) {
                        element.setAttribute("aria-expanded", "false");
                        element.classList.remove("show");
                    } else {
                        element.setAttribute("aria-expanded", "true");
                        element.classList.add("show");
                    }
                    const menu = dropdown.querySelector('.dropdown-menu');
                    if (menu) {
                        if (expanded) {
                            menu.classList.remove("show");
                        } else {
                            menu.classList.add("show");
                        }
                    }
                }
            })
        }
    }
})();